import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { BfiDataGrid, Column, Summary, TotalItem } from '../../common/SharedComponents';
import { ExperienceGrandTotalTypeOptions, GridSettingType } from '@apply/constants';
import { ExperienceApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';

const ExperienceGrandTotalsTable = ({ principalId, gridStore }) => {
    const searchState = useSelector((state) => state.searchState);
    const experienceApi = new ExperienceApi.ExperienceApi(applicationInsights);
    const [dataStore, set_dataStore] = useState(gridStore?.store);

    const dataFunction = () => {
        return experienceApi.getExperienceGrandTotals(principalId);
    };

    useEffect(() => {
        if (gridStore) {
            gridStore.setOnLoad('experienceGrandTotalTypeId', dataFunction, searchState?.searchText?.experience);
            set_dataStore(gridStore.store);
        }
    }, [gridStore]);

    const onExperienceGrandTotalTypeRender = (e) => {
        const option = ExperienceGrandTotalTypeOptions.find((a) => a.id === e.value);
        if (!option) {
            return null;
        }
        return option.name;
    };

    return (
        <BfiDataGrid
            gridType={GridSettingType.ExperienceGrandTotalsTable}
            dataStore={dataStore}
            applicationInsights={applicationInsights}
            width={'100%'}
        >
            <Column
                dataField='experienceGrandTotalTypeId'
                caption=''
                alignment='left'
                cellRender={onExperienceGrandTotalTypeRender}
                width={200}
            />
            <Column
                dataField='experienceTotalAmount'
                caption='Total'
                alignment='center'
                width={80}
            />
        </BfiDataGrid>
    );
};

export default ExperienceGrandTotalsTable;
